/**
 * Global viewless component.
 */
import useChannels from '@shared/components/utils/hooks/useChannels';
import useDeadman from '@shared/components/utils/hooks/useDeadman';
import useEvents from '@shared/components/utils/hooks/useEvents';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import useLogin from '@shared/components/utils/hooks/useLogin';
import useMagicRemote from '@shared/components/utils/hooks/useMagicRemote';
import useNetwork from '@shared/components/utils/hooks/useNetwork';
import useParental from '@shared/components/utils/hooks/useParental';
import useRecords from '@shared/components/utils/hooks/useRecords';
import useVisibility from '@shared/components/utils/hooks/useVisibility';
import { initAction } from '@shared/actions/flow';
import { useEffect } from 'react';

export default function Global() {
  // Inititialize application
  useEffect(initAction, []);

  // Set request tasks
  useChannels();
  useEvents();
  useLogin();
  useRecords();

  // Set background tasks
  const { resetDeadman } = useDeadman();
  useMagicRemote();
  useNetwork();
  useParental();
  useVisibility();

  // Set global keyboard
  useKeyboard({ canBeFocused: false, keyDownHandler: resetDeadman });

  return null;
}
